function event_to_relative (event) {
  let dim = event.target.getBoundingClientRect();
  let x = parseInt(event.clientX - dim.left);
  let y = parseInt(event.clientY - dim.top);
  return {x, y};
}

function deep_copy (obj) {
  return JSON.parse(JSON.stringify(obj));
}

export {event_to_relative, deep_copy}



// WEBPACK FOOTER //
// ./assets/js/utils.js